module.exports = __webpack_public_path__ + "static/media/HGET-BNB.664b2d83.svg";